var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOperationBcsh(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.5L8.25 3.5C7.875 3 7 2.5 6.25 2.5H2.5M22.5 7.5L13.75 17.5L5 7.5H22.5Z",
    stroke: "#186419",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 11.3754C20.114 12.1142 21.204 12.5365 22.3403 12.5727C23.4766 12.6088 24.5913 12.2567 25.5005 11.5744C26.4098 10.892 27.0594 9.92017 27.3423 8.81906C27.6251 7.71796 27.5242 6.55335 27.0563 5.51727C26.5884 4.48118 25.7814 3.63548 24.7683 3.11962C23.7552 2.60375 22.5966 2.44851 21.4835 2.6795C20.3704 2.91049 19.3692 3.51392 18.645 4.39029C17.9209 5.26666 17.517 6.36364 17.5 7.50035M13.75 17.5004V27.5004M8.75 27.5004H18.75",
    stroke: "#186419",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationBcsh);
export default __webpack_public_path__ + "static/media/OperationBCSH.f1af5e396b2d9f7dffcd4c7af0ca0f0b.svg";
export { ForwardRef as ReactComponent };